export default "__VITE_ASSET__6631d56a__"